<template>
  <div class="third-party-container">
    <header>
      <span class="title">第三方对照表</span>
      <div class="right">
        <el-button size="small" @click="dialogDelete = true" :disabled="multipleSelection.length === 0">删  除</el-button>
        <el-button type="primary" @click="AddDialog(1)" :disabled="multipleSelection.length !== 1">编 辑</el-button>
        <el-button type="primary" @click="AddDialog">新 增</el-button>
      </div>
    </header>
    <el-table class="el-table-01" :data='tableList' style='width: 100%;height: calc(100% - 60px);' @selection-change="handleSelectionChange">
      <el-table-column type='selection' width='55'></el-table-column>
      <el-table-column prop='assembly_id' label='开通版本' min-width='160'>
        <template slot-scope='scope'>
          <span v-text="assemblyInit(scope.row.assembly_id)"></span>
        </template>
      </el-table-column>
      <el-table-column prop='component_version_id' label='组件版本' min-width='140'>
        <template slot-scope='scope'>
          <span v-text="componentInit(scope.row.component_version_id)"></span>
        </template>
      </el-table-column>
      <el-table-column prop='seat' label='开通坐席' min-width='140'></el-table-column>
      <el-table-column prop='accessory_space' label='附件空间' min-width='140'></el-table-column>
      <el-table-column prop='total_data_volume' label='总数据量' min-width='140'></el-table-column>
      <el-table-column prop='itemcode' label='钉钉-规格码' min-width='160'></el-table-column>
      <el-table-column prop='qyversion_id' label='企业微信规格码' min-width='180'></el-table-column>
    </el-table>

    <div class="mask n1" v-if="dialogAdd" @click="dialogAdd = false"></div>
    <transition name="slide">
      <el-container class="add-dialog component-add-dialog" v-if="dialogAdd">
        <header>
          <span>第三方对照表</span>
          <i class="iconfont icon-close" @click="dialogAdd = false"></i>
        </header>
        <div class="content">
          <div class="banner">
            <div class="h1">第三方对照表</div>
            <div class="h2">用于中央控制台的版本与钉钉、企业微信规格对应</div>
          </div>
          <div class="form">
            <div class="form-header">基本信息</div>
            <div class="form-content">
              <div class="form-item">
                <span class="item-title"><span class="need">*</span>开通版本</span>
                <div class="item-right">
                  <el-select v-model="form.version" placeholder="请选择(必填)">
                    <el-option v-for="item in vOptions" :key="item.id" :label="item.version_name" :value="item.id"></el-option>
                  </el-select>
                </div>
                <div class="err" v-if="err.version"><i class="el-icon-warning"></i>{{err.version}}</div>
              </div>
              <div class="form-item">
                <span class="item-title"><span class="need">*</span>组件版本</span>
                <div class="item-right">
                  <el-select v-model="form.field_typesId" placeholder="请选择(必填)" size="medium">
                    <el-option v-for="item in componentData" :key="item.id" :label="item.cm_name" :value="item.id"></el-option>
                  </el-select>
                </div>
                <div class="err" v-if="err.field_types"><i class="el-icon-warning"></i>{{err.field_types}}</div>
              </div>
              <div class="form-item">
                <span class="item-title"><span class="need">*</span>开通坐席</span>
                <div class="item-right">
                  <el-input v-model="form.peopleNumber" placeholder="请输入(必填)" size="medium" type="number" suffix-icon="iconfont icon-shuzi1"></el-input>
                </div>
                <div class="err" v-if="err.peopleNumber"><i class="el-icon-warning"></i>{{err.peopleNumber}}</div>
              </div>
              <div class="form-item">
                <span class="item-title"><span class="need">*</span>附件空间</span>
                <div class="item-right">
                  <el-input v-model="form.attachment" placeholder="请输入(必填)" size="medium" class="gb" type="number">
                  </el-input>
                </div>
                <div class="err" v-if="err.attachment"><i class="el-icon-warning"></i>{{err.attachment}}</div>
              </div>
              <div class="form-item">
                <span class="item-title"><span class="need">*</span>总数据量</span>
                <div class="item-right">
                  <el-input v-model="form.dataSize" placeholder="请输入(必填)" size="medium" class="tiao" type="number">
                  </el-input>
                </div>
                <div class="err" v-if="err.dataSize"><i class="el-icon-warning"></i>{{err.dataSize}}</div>
              </div>
              <div class="form-item">
                <span class="item-title item-title2"><span>钉钉</span><span>规格码</span></span>
                <div class="item-right">
                  <el-input v-model="form.itemcode" placeholder="请输入" size="medium">
                  </el-input>
                </div>
                <div class="err" v-if="err.itemcode"><i class="el-icon-warning"></i>{{err.itemcode}}</div>
              </div>
              <div class="form-item">
                <span class="item-title item-title2"><span>企业微信</span><span>规格码</span></span>
                <div class="item-right">
                  <el-input v-model="form.qyversion_id" placeholder="请输入" size="medium"></el-input>
                </div>
                <div class="err" v-if="err.qyversion"><i class="el-icon-warning"></i>{{err.qyversion}}</div>
              </div>
              <div class="form-item">
                <span class="item-title">是否默认</span>
                <div class="item-right">
                  <el-radio-group v-model="form.is_default">
                    <el-radio :label="0">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer>
          <el-button @click="dialogAdd = false">取 消</el-button>
          <el-button type="primary" @click="dialogSave">保 存</el-button>
        </footer>
      </el-container>
    </transition>
    <el-dialog title="提示" :visible.sync="dialogDelete" class="prompt-box" append-to-body>
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">删除</div>
      <div class="note">删除后不可恢复。</div>
      <div class="prompt">确定要删除该数据吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDelete = false">取 消</el-button>
        <el-button type="primary" @click="deleteThirdParty">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {HTTPServer} from '@/common/js/ajax.js'
import mixin from '@/common/js/mixins.js'
export default {
  data () {
    return {
      defaultMsg: '<b>第三方对照表</b>',
      searchInput: '',
      disabled: false,
      tableList: [],
      moduleId: 7,
      multipleSelection: [],
      componentData: [],
      dialogDetail: false,
      dialogAdd: false,
      dialogDelete: false,
      form: {},
      err: {
        version: '',
        field_types: '',
        peopleNumber: '',
        attachment: '',
        dataSize: '',
        itemcode: '',
        qyversion: ''
      }
    }
  },
  components: {
  },
  mixins: [mixin],
  mounted () {
    this.queryAllChargingStrategy()
    this.getEnableComponentManageList()
    this.findThirdParty()
    // this.queryFchBtnAuth(({moduleId: 17}))
  },
  methods: {
    assemblyInit (id) {
      let v = this.vOptions.find(v => {
        return v.id === id
      })
      return v ? v.version_name : '-'
    },
    componentInit (id) {
      let v = this.componentData.find(v => {
        return v.id === id
      })
      return v ? v.cm_name : '-'
    },
    /** 获取 组件管理 */
    findThirdParty () {
      HTTPServer.findThirdParty({}, 'Loading').then((res) => {
        this.tableList = res
      })
    },
    /** 新增增购弹窗 */
    AddDialog (type) {
      this.form = {is_default: 0}
      this.err = {
        version: '',
        field_types: '',
        peopleNumber: '',
        attachment: '',
        dataSize: '',
        itemcode: '',
        qyversion: ''
      }
      if (type === 1) {
        if (this.multipleSelection.length !== 1) {
          return
        }
        let obj = JSON.parse(JSON.stringify(this.multipleSelection[0]))
        this.form = {
          id: obj.id,
          version: obj.assembly_id,
          field_typesId: obj.component_version_id,
          peopleNumber: obj.seat,
          attachment: obj.accessory_space,
          dataSize: obj.total_data_volume,
          itemcode: obj.itemcode,
          qyversion_id: obj.qyversion_id,
          is_default: obj.is_default
        }
      }
      this.dialogAdd = true
    },
    /** 获取 组件管理 */
    getEnableComponentManageList () {
      HTTPServer.getEnableComponentManageList({}, 'Loading').then((res) => {
        this.componentData = res
      })
    },
    /** 保存 */
    dialogSave () {
      let reg = /^[1-9]\d*$/
      this.err = {
        version: '',
        field_types: '',
        peopleNumber: '',
        attachment: '',
        dataSize: '',
        itemcode: '',
        qyversion: ''
      }
      if (!this.form.version) {
        this.err.version = '开通版本不能为空'
        return false
      }
      if (!this.form.field_typesId) {
        this.err.field_types = '组件版本不能为空'
        return false
      }
      if (!this.form.peopleNumber) {
        this.err.peopleNumber = '开通坐席不能为空'
        return false
      }
      if (!reg.test(this.form.peopleNumber)) {
        this.err.peopleNumber = '开通坐席只能为正整数'
        return false
      }
      if (!this.form.attachment) {
        this.err.attachment = '附件空间不能为空'
        return false
      }
      if (!reg.test(this.form.attachment)) {
        this.err.attachment = '附件空间只能为正整数'
        return false
      }
      if (!this.form.dataSize) {
        this.err.dataSize = '总数据量不能为空'
        return false
      }
      if (!reg.test(this.form.dataSize)) {
        this.err.dataSize = '总数据量只能为正整数'
        return false
      }
      console.log(this.form)
      var jsondata = {
        assembly_id: this.form.version, // 开通版本id
        component_version_id: this.form.field_typesId, // 组件版本
        seat: this.form.peopleNumber, // 开通坐席
        accessory_space: this.form.attachment, // 附件空间
        total_data_volume: this.form.dataSize, // 总数据量
        itemcode: this.form.itemcode, // 钉钉规格码
        qyversion_id: this.form.qyversion_id, // 企业微信规格码
        is_default: this.form.is_default
      }
      if (this.form.id) {
        jsondata.id = this.form.id
      }
      HTTPServer.saveThirdParty(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '保存成功！',
          type: 'success'
        })
        this.dialogAdd = false
        this.findThirdParty()
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
    },
    /** 删除 */
    deleteThirdParty () {
      let arr = []
      this.multipleSelection.map((item) => {
        arr.push(item.id)
      })
      HTTPServer.deleteThirdParty(arr, 'Loading').then((res) => {
        this.dialogDelete = false
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.findThirdParty()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/business/third-party.vue